import React from 'react';
import useLocalStorage from 'use-local-storage';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { dominioDemandaCirurgica } from '../../config/database';

export default function ImpressaoSolicitacaoAIHProcedimentoSolicitado({
  alterarPassoDadosAIH,
  handleFechaSolicitacaoAIH,
  listarPedidosCirurgia,
}) {
  const [solicitacaoAIH, setSolicitacaoAIH] = useLocalStorage('solicitacaoAIH', undefined);

  const handleSubmit = e => {
    e.preventDefault();

    const dados = {
      numeroProntuario: solicitacaoAIH.numeroProntuario,
      nome: solicitacaoAIH.nome,
      cns: solicitacaoAIH.cns,
      dataNascimento: solicitacaoAIH.dataNascimento,
      sexo: solicitacaoAIH.sexo,
      raca: solicitacaoAIH.raca,
      etnia: solicitacaoAIH.etnia,
      nomeMae: solicitacaoAIH.nomeMae,
      telefoneMae: solicitacaoAIH.telefoneMae,
      nomeResponsavel: solicitacaoAIH.nomeResponsavel,
      telefoneResponsavel: solicitacaoAIH.telefoneResponsavel,
      municipioResidencia: solicitacaoAIH.municipioResidencia,
      codigoMunicipioIBGE: solicitacaoAIH.codigoMunicipioIBGE,
      uf: solicitacaoAIH.uf,
      cep: solicitacaoAIH.cep,
      paciente: solicitacaoAIH.paciente,
      pedidoCirurgia: solicitacaoAIH.pedidoCirurgia,
      principaisSinaisSintomas: solicitacaoAIH.principaisSinaisSintomas,
      justificativasInternacao: solicitacaoAIH.justificativasInternacao,
      principaisResultadosProvasDiagnosticas: solicitacaoAIH.principaisResultadosProvasDiagnosticas,
      diagnosticoInicial: solicitacaoAIH.diagnosticoInicial,
      cidPrincipal: solicitacaoAIH.cidPrincipal.id,
      cidSecundario: solicitacaoAIH.cidSecundario ? solicitacaoAIH.cidSecundario.id : undefined,
      cidCausasAssociadas: solicitacaoAIH.cidCausasAssociadas
        ? solicitacaoAIH.cidCausasAssociadas.id
        : undefined,
      descricaoProcedimentoSolicitado: solicitacaoAIH.descricaoProcedimentoSolicitado,
      codigoProcedimento: solicitacaoAIH.codigoProcedimento,
      clinica: solicitacaoAIH.clinica,
      caraterInternacao: solicitacaoAIH.caraterInternacao,
      documento: solicitacaoAIH.documento,
      numeroDocumentoProfissional: solicitacaoAIH.numeroDocumentoProfissional,
      nomeProfissional: solicitacaoAIH.nomeProfissional,
      endereco: solicitacaoAIH.endereco,
    };
    dominioDemandaCirurgica.post(`/api/dadosImpressaoSolicitacaoAIH`, dados).then(async () => {
      await dominioDemandaCirurgica().then(promise => {
        window.open(`${promise.config.baseURL}/solicitacaoAIH/${solicitacaoAIH.pedidoCirurgia}`);
      });

      handleFechaSolicitacaoAIH();
      listarPedidosCirurgia();
      document.location.reload(true);
    });
  };

  return (
    <Container style={{ height: '100%' }}>
      <b>Procedimento solicitado</b>
      <br />
      <br />
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={9} sm={9}>
            <TextField
              autoComplete="off"
              name="descricaoProcedimentoSolicitado"
              variant="outlined"
              fullWidth
              id="descricaoProcedimentoSolicitado"
              label="Descrição do procedimento solicitado"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.descricaoProcedimentoSolicitado : undefined}
              onChange={e => {
                const solicitacao = {
                  ...solicitacaoAIH,
                  descricaoProcedimentoSolicitado: e.target.value,
                };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={3} sm={3}>
            <TextField
              autoComplete="off"
              name="codigoProcedimento"
              variant="outlined"
              fullWidth
              id="codigoProcedimento"
              label="Código do procedimento"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.codigoProcedimento : undefined}
              onChange={e => {
                const solicitacao = { ...solicitacaoAIH, codigoProcedimento: e.target.value };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={3} sm={3}>
            <TextField
              autoComplete="off"
              name="clinica"
              variant="outlined"
              fullWidth
              id="clinica"
              label="Clínica"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.clinica : undefined}
              onChange={e => {
                const solicitacao = { ...solicitacaoAIH, clinica: e.target.value };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={3} sm={3}>
            <TextField
              autoComplete="off"
              name="caraterInternacao"
              variant="outlined"
              fullWidth
              id="caraterInternacao"
              label="Caráter da internação"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.caraterInternacao : undefined}
              onChange={e => {
                const solicitacao = { ...solicitacaoAIH, caraterInternacao: e.target.value };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={3} sm={3}>
            <TextField
              autoComplete="off"
              name="documento"
              variant="outlined"
              fullWidth
              id="documento"
              label="Documento"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.documento : undefined}
              onChange={e => {
                const solicitacao = { ...solicitacaoAIH, documento: e.target.value };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={3} sm={3}>
            <TextField
              autoComplete="off"
              name="numeroDocumentoProfissional"
              variant="outlined"
              fullWidth
              id="numeroDocumentoProfissional"
              label="Nº Documento do profissional solicitante"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.numeroDocumentoProfissional : undefined}
              onChange={e => {
                const solicitacao = {
                  ...solicitacaoAIH,
                  numeroDocumentoProfissional: e.target.value,
                };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              autoComplete="off"
              name="nomeProfissional"
              variant="outlined"
              fullWidth
              id="nomeProfissional"
              label="Nome do profissional solicitante"
              InputLabelProps={{ shrink: true }}
              value={solicitacaoAIH ? solicitacaoAIH.nomeProfissional : undefined}
              onChange={e => {
                const solicitacao = { ...solicitacaoAIH, nomeProfissional: e.target.value };
                setSolicitacaoAIH(solicitacao);
              }}
              inputProps={{ maxLength: 500, style: { textTransform: 'uppercase' } }}
              required
            />
          </Grid>
          <Grid item xs={8} sm={8} />
          <Grid item xs={2} sm={2}>
            <Button
              onClick={() => {
                alterarPassoDadosAIH(1);
              }}
              style={{ float: 'right' }}
              variant="contained"
              color="warning"
            >
              Voltar
            </Button>
          </Grid>
          <Grid item xs={2} sm={2}>
            <Button type="submit" variant="contained" color="primary" style={{ float: 'right' }}>
              Próximo
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
}
